import styles from '@/styles/combo.module.scss';

export interface PizzaOptionSkeletonProps {
  count?: number;
}

export default function PizzaOptionSkeleton({ count = 4 }: PizzaOptionSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, skeletonIndex) => (
        <div 
          key={`skeleton-${skeletonIndex}`} 
          className={`${styles.optionCard}`} 
          style={{ opacity: 0.6, pointerEvents: 'none' }}
        >
          {/* Checkbox Skeleton */}
          <div 
            className={`${styles.checkmark} ${styles.skeletonPulse}`}
            style={{ 
              width: '20px', 
              height: '20px', 
              backgroundColor: '#e0e0e0', 
              borderRadius: '3px',
            }}
          ></div>

          {/* Image Skeleton */}
          <div 
            className={`${styles.optionImage} ${styles.skeletonPulse}`}
            style={{ 
              backgroundColor: '#e0e0e0', 
              borderRadius: '100%',
              height: '60px !important',
              width: '60px !important'
            }}
          ></div>

          {/* Text Content Skeleton */}
          <div style={{ width: 'calc(100% - 168px)', marginTop: '8px' }}>
            {/* Title Line 1 */}
            <div
              className={styles.textSkeleton}
              style={{ 
                height: '14px', 
                backgroundColor: '#e0e0e0', 
                width: '100%',
                maxWidth: '80%', 
                borderRadius: '4px', 
                marginBottom: '6px',
              }}
            ></div>

            {/* Price/Size Info */}
            <div 
              className={styles.textSkeleton}
              style={{ 
                height: '12px', 
                backgroundColor: '#e0e0e0', 
                borderRadius: '4px', 
                width: '60%',
              }}
            ></div>
          </div>

          {/* Vegetarian Indicator Skeleton */}
          <div 
            className={styles.skeletonPulse}
            style={{ 
              width: '16px', 
              height: '16px', 
              backgroundColor: '#e0e0e0', 
              borderRadius: '50%',
              marginTop: '8px',
            }}
          ></div>
          {/* Vegetarian Indicator Skeleton */}
          <div 
            className={styles.skeletonPulse}
            style={{ 
              width: '8px', 
              height: '16px', 
              backgroundColor: '#e0e0e0', 
              marginTop: '8px',
            }}
          ></div>
        </div>
      ))}
    </>
  );
}
